// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"296":"1a27a95d","304":"c1772a5c","351":"696463dd","508":"25cf4516","727":"6ec5f305","975":"b0db34ef"}[chunkId] + ".css";
};